import {
  Box,
  Grid,
  GridItem,
  Radio,
  RadioGroup,
  Stack
} from "@/storybook-components";
import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { LikertQuestionProps } from "../types";

export const LikertQuestion = (props: LikertQuestionProps) => {
  const {
    spacing,
    isRequired,
    isInvalid,
    labelClassName,
    isDisabled,
    questionId,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    layoutProps,
    contentLayoutProps,
    answerLabelProps,
    answer,
    size,
    handleChange,
    statements,
    answerStackSpacing,
    answerGroupSpacing,
    answerBlockSpacing,
    options,
    answerProps,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps
  } = props;

  const headerFooterProps = {
    spacing,
    isRequired,
    isInvalid,
    layoutProps,
    labelClassName,
    questionId,
    isDisabled,
    questionLabel,
    questionLabelType,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent spacing={answerStackSpacing} {...contentLayoutProps}>
        {statements?.map((statement) => (
          <Box as="fieldset" key={statement.id}>
            <Stack spacing={answerGroupSpacing}>
              <Box
                as="legend"
                className="ehq-likertStatement"
                id={`ehq-${questionId}-${statement.id}-group`}
                {...answerLabelProps}
              >
                {statement.question}
              </Box>
              <RadioGroup
                value={answer[statement.id]}
                size={size}
                onChange={(value) => handleChange(value, statement.id)}
              >
                <Grid templateColumns="repeat(12, 1fr)">
                  <GridItem colSpan={12} overflow="hidden">
                    <Stack
                      direction={{ base: "column", lg: "row" }}
                      spacing={answerBlockSpacing}
                      p={{ base: 0, lg: 3 }}
                      overflowX="auto"
                      sx={{
                        "&::-webkit-scrollbar": {
                          height: 2
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "gray.200",
                          borderRadius: 6
                        },
                        scrollbarWidth: "thin",
                        scrollbarColor: "#E2E8F0 white"
                      }}
                      {...contentLayoutProps}
                    >
                      {options &&
                        options.map((option) => (
                          <Box
                            key={option.id}
                            maxWidth={60}
                            flexShrink={0}
                            flexBasis="auto"
                          >
                            <Radio
                              key={option.id}
                              value={option.id}
                              size="xlIconWithLabelStyle"
                              {...answerProps}
                            >
                              {option.name}
                            </Radio>
                          </Box>
                        ))}
                    </Stack>
                  </GridItem>
                </Grid>
              </RadioGroup>
            </Stack>
          </Box>
        ))}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
